import { z } from 'zod';

const PageSchema = z.object({
  id: z.string(),
  title: z.string(),
  url: z.string(),
  new_window: z.boolean().optional(),
  icon: z.string().nullish(),
  icon_style: z
    .object({
      key: z.enum(['solid', 'outline']),
    })
    .optional(),
});

export type PrimaryNavigationPage = z.infer<typeof PageSchema>;

const PrimaryNavigationItemSchema: z.ZodType<any> = z.lazy(() =>
  z.object({
    page: PageSchema,
    depth: z.number().positive(),
    children: z.array(PrimaryNavigationItemSchema),
  })
);

// We can't use z.infer from Zod to get the interface when we use 'lazy'
export interface PrimaryNavigationItem {
  page: PrimaryNavigationPage;
  depth: number;
  children: PrimaryNavigationItem[];
}

const PrimaryNavigationSchema = z.object({
  data: z.array(PrimaryNavigationItemSchema),
});

export type PrimaryNavigationResponse = z.infer<typeof PrimaryNavigationSchema>;

export { PrimaryNavigationSchema };
